import { QueryClient } from "@tanstack/react-query";
import { shouldRetryQuery } from "./queryRetry";

/**
 * Module singleton rather than client-in-state so non-hook code can read the
 * cache synchronously (e.g. userDirectory's getUserName during CO-comment
 * decoding). Tests share this instance — tests/setup.ts clears it after
 * each test.
 *
 * refetchOnWindowFocus stays off: the app has its own focus/poll semantics
 * (job monitor focus re-kick, interval pollers) and a surprise refetch storm
 * on tab switches would change behavior.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: shouldRetryQuery,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});
